module.exports = __webpack_public_path__ + "06_long_gray.ecdeb0ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/06_long_gray.png
// module id = 287A
// module chunks = 0